module.exports = __webpack_public_path__ + "fonts/AvenirBold.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/AvenirBold.woff2
// module id = 480
// module chunks = 12